import React from 'react';
import ComingSoon from '../common/ComingSoon';

function Exams() {
  return <ComingSoon title="Exams Management" />;
}

export default Exams;
